module.exports = __webpack_public_path__ + "images/emails/i-reply-9ce46e4a.gif";